import { Routes } from '@angular/router';
import { BaseLayout } from './base-layout/base-layout';
import { Logs } from './pages/school/school-logs/logs';
import { Dashboard } from './pages/dashboard/dashboard';
import { Login } from './login/login';
import { AuthGuard } from './guards/auth.guard';
import { PageNotFound } from './page-not-found/page-not-found';
import { LogsView } from './logs-view/logs-view';
import { BookingView } from './pages/school/logs-view-comp/booking-view/booking-view';
import { MyList } from './pages/school/logs-view-comp/my-list/my-list';
import { ProfileEdit } from './pages/school/profile-edit/profile-edit';
import { TeacherProfile } from './view-logs-components/teacher-profile/teacher-profile';

export const routes: Routes = [
  {
    path: '',
    component: BaseLayout,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: Login },
      { path: 'logs', component: Logs, canActivate: [AuthGuard] },
      { path: 'dashboard', component: Dashboard, canActivate: [AuthGuard] },
      { path: 'logs-view', component: LogsView, canActivate: [AuthGuard] }, // New route
      { path: 'booking-view', component: BookingView, canActivate: [AuthGuard] }, // New route
      { path: 'school-my-teacher', component: MyList, canActivate: [AuthGuard] }, // New route
      { path: 'school-profile', component: ProfileEdit, canActivate: [AuthGuard] }, // New route
      { path: 'teacher-profile', component: TeacherProfile, canActivate: [AuthGuard] }, // New route
      { path: 'invite-teacher', component: TeacherProfile, canActivate: [AuthGuard] }, // New route
      { path: 'invite-school', component: TeacherProfile, canActivate: [AuthGuard] }, // New route
    ],
  },
  // Wildcard route for a 404 page
  { path: '**', component: PageNotFound },
];
